module.exports = __webpack_public_path__ + "static/_0000_GREENMONTANA-fdde724c8ce1ee57d9328d4807034ee8.jpg";